import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import KomalHero from './components/KomalHero';
import ShowreelSection from './components/ShowreelSection';
import ShadesGallery from './components/ShadesGallery';
import AboutKomal from './components/AboutKomal';
import IntroVideoSection from './components/IntroVideoSection';
import PortraitGallery from './components/PortraitGallery';
import SkillsTraining from './components/SkillsTraining';
import WorkProjects from './components/WorkProjects';
import UnreleasedWork from './components/UnreleasedWork';
import ContactKomal from './components/ContactKomal';
import FooterKomal from './components/FooterKomal';
import PortraitGalleryOptions from './pages/PortraitGalleryOptions';
import MobileMockups from './pages/MobileMockups';
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './pages/AdminLogin';
import CinematicPortfolio from './pages/CinematicPortfolio';
import AdminPortfolioEditor from './pages/AdminPortfolioEditor';
import WorkPage from './pages/WorkPage';
import ProtectedRoute from './components/ProtectedRoute';
import { Toaster } from './components/ui/toaster';

const ScrollToHash = () => {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const timeout = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
      return () => clearTimeout(timeout);
    }
    // No hash → scrolled-in route change → reset to top of page
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [hash, pathname]);
  return null;
};

const MainPortfolio = () => (
  <>
    <KomalHero />
    <AboutKomal />
    <IntroVideoSection />
    <ShowreelSection />
    <PortraitGallery />
    <SkillsTraining />
    <ShadesGallery />
    <WorkProjects />
    <UnreleasedWork />
    <ContactKomal />
    <FooterKomal />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <div className="App bg-black">
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<MainPortfolio />} />
          <Route path="/portfolio" element={<CinematicPortfolio />} />
          <Route path="/work" element={<WorkPage />} />
          <Route path="/portrait-options" element={<PortraitGalleryOptions />} />
          <Route path="/mobile-mockups" element={<MobileMockups />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route
            path="/admin/portfolio"
            element={
              <ProtectedRoute>
                <AdminPortfolioEditor />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
